import React from 'react';
import { Customer } from '../../../types/models/customer';
import { CustomerItem } from './customer-item';

interface CustomersProps {
  customers: Array<Customer>;
  onCustomerDeleted: () => void;
}

/**
 * Results of a customer lookup.
 *
 * Was a `react-virtualized` window over the whole customer table. With lookup
 * now by exact email there is at most one row, so the virtualisation — and the
 * dependency — are gone.
 */
export function Customers({ customers, onCustomerDeleted }: CustomersProps) {
  if (customers.length === 0) return null;
  return (
    <div>
      {customers.map((customer) => (
        <CustomerItem key={customer.id} customer={customer} onDeleted={onCustomerDeleted} />
      ))}
    </div>
  );
}
